import { Services } from '@spectorasoftware/homegauge-services';
import ServiceErrorHandler from './service-error-handler';

const {
  AuthService,
  ClassicService,
  CompanyService,
  CustomerService,
  DocumentService,
  FolderService,
  HomebuyerOffersService,
  InspectorService,
  OfferService,
  PersonService,
  LeadsService,
} = Services;

class ApiContainer {
  constructor() {
    this.authService = null;
    this.classicService = null;
    this.companyService = null;
    this.customerService = null;
    this.documentService = null;
    this.featureService = null;
    this.folderService = null;
    this.homebuyerOffersService = null;
    this.inspectorService = null;
    this.offerService = null;
    this.personService = null;
    this.LeadsService = null;
  }

  init() {
    const API_URL = process.env.VUE_APP_ROOT_API;
    const API_AUTH_BASIC_USER = process.env.VUE_APP_AUTH_SVC_BASIC_USER;
    const API_AUTH_URL = process.env.VUE_APP_AUTH_SVC_URL;
    const CLASSIC_URL = process.env.VUE_APP_HG_CLASSIC;
    const HOMEBUYER_URL = process.env.VUE_APP_HOMEBUYER_URL;

    const serviceConfig = {
      errorHandler: ServiceErrorHandler,
    };

    this.authService = new AuthService(
      API_AUTH_URL,
      { classicUrl: CLASSIC_URL },
      API_AUTH_BASIC_USER,
    );
    this.classicService = new ClassicService(CLASSIC_URL);
    this.companyService = new CompanyService(API_URL, serviceConfig);
    this.customerService = new CustomerService(API_URL, serviceConfig);
    this.documentService = new DocumentService(API_URL, serviceConfig);
    this.folderService = new FolderService(API_URL, serviceConfig);
    this.homebuyerOffersService = new HomebuyerOffersService(HOMEBUYER_URL, serviceConfig);
    this.inspectorService = new InspectorService(API_URL, serviceConfig);
    this.offerService = new OfferService(API_URL, serviceConfig);
    this.personService = new PersonService(API_URL, serviceConfig);
    this.LeadsService = new LeadsService(API_URL, serviceConfig);
  }
}

export { ApiContainer };
export default new ApiContainer();
